import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] grid place-items-center px-4">
      <div className="text-center">
        <div className="font-display text-6xl font-bold text-[hsl(var(--aito-lagoon))]">404</div>
        <p className="mt-3 text-muted-foreground">Cette page n'existe pas (encore).</p>
        <Link to="/" className="mt-5 inline-block"><Button className="bg-[hsl(var(--aito-lagoon))] text-black hover:bg-[hsl(var(--aito-lagoon-2))]">Retour à l'accueil</Button></Link>
      </div>
    </div>
  );
}
